<template>
    <section>
        <div id="subHeader">
            <h1>Podcasts</h1>
            <h2>Sente-se e ouça</h2>
        </div>
        <div class="container-fluid" id="main">
            <div class="row">

                <div class="col-12 col-sm-12 col-md-8 col-xl-9 mb-5">
                    <div class="row">
                        <router-link :key="podcast.id" :to="{name: 'podcast', params: {uuid: podcast.uuid}}"
                                     class="col-md-6 podcast p-3" v-for="podcast in podcasts.data">
                            <div class="card">
                                <div class="card-body p-0">
                                    <div class="row m-0">
                                        <div class="col-4 col-md-12 col-xl-5 p-0">
                                            <img alt="" class="p-0" :src="podcast.image">
                                        </div>
                                        <div class="col-8 col-md-12 col-xl-7 p-0 d-flex">
                                            <div class="m-auto text-center">
                                                <p class="p-3 m-0">{{ podcast.title }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer text-right">
                                    <small>{{ podcast.created_at }}</small>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>

                <div class="col d-flex p-0" id="pager">
                    <div class="m-auto">
                        <div class="text-center pb-5">
                            <h1>{{ podcasts.current_page }}</h1>
                            <h2>Página</h2>
                        </div>
                        <div class="text-center">
                            <a @click.prevent="getResults(podcasts.current_page - 1)" href="javascript:void(0)"
                               id="prev"
                               v-if="podcasts.current_page > 1">
                                <img alt="" src="/images/seta_tras.png">
                                <button>Anterior</button>
                            </a>
                            <br>
                            <a @click.prevent="getResults(podcasts.current_page + 1)" href="javascript:void(0)"
                               id="next"
                               v-if="podcasts.current_page < podcasts.last_page">
                                <button>Próxima</button>
                                <img alt="" src="/images/seta_tras.png">
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Podcasts",
        metaInfo: {
            title: 'Podcasts',
        },
        data() {
            return {
                podcasts: {current_page: 1, data: []}
            }
        },
        methods: {
            getResults(page = 1) {
                axios.post('/podcasts', {page})
                    .then(rsp => this.podcasts = rsp.data)
            }
        },
        mounted() {
            this.$parent.image = '/images/podcasts.jpg';
        },
        beforeRouteEnter(to, from, next) {
            axios.post('/podcasts')
                .then(rsp => next(vm => vm.podcasts = rsp.data))
        }
    }
</script>

<style lang="scss" scoped>
    .podcast {
        text-decoration: none;
        color: #fff;
    }

    .podcast:hover {
        text-decoration: none;
        color: lightgrey;
    }

    .podcast div {
        overflow: hidden;
    }

    .podcast:hover img {
        filter: grayscale(100%);
        width: 105%;
    }

    .podcast > .card:hover {
        background-color: rgba(0, 0, 0, .5);
    }

    .podcast img {
        height: 25vh;
        width: 100%;
        object-fit: cover;
        object-position: center;
    }

    .podcast > .card {
        background-color: rgba(0, 0, 0, .25);
        border-color: rgba(0, 0, 0, .6);
    }

    .podcast > .card > .card-footer {
        background-color: rgba(22, 29, 30, 1);
    }

    #pager h1 {
        font-size: 25vh;
        line-height: 19vh;
        color: #A8BCB3;
        font-family: Helvetica, serif !important;
        font-weight: bold !important;
    }

    #pager h2 {
        color: #A8BCB3;
        font-family: Helvetica, serif !important;
        font-weight: bold !important;
    }

    #pager #next,
    #pager #prev {
        position: relative;
        display: inline-flex;

        > button {
            background: none;
            border: none;
            font-size: 1.6rem;
            height: 1.6rem;
            color: #fff;
            text-transform: uppercase;
            padding: 0 2rem;
            margin: auto 0;
        }

        > img {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 1.6rem;
            height: auto;
            margin: auto 0;
        }

    }

    #pager #next > img {
        transform: scaleX(-1);
        right: 0;
    }

    #pager #prev > img {
        left: 0;
    }

    @media screen and (max-width: 774px) {
        #pager {
            flex-grow: 1 !important;
        }
    }
</style>